module.exports = __webpack_public_path__ + "static/media/recrutement_manag1.50a592f7.PNG";